import * as yup from 'yup';

export const appointmentFormSchema = yup.object().shape({
  date: yup
    .string()
    .required(),
  note: yup
    .string()
    .nullable()
    .defined(),
  slot: yup
    .object()
    .required()
    .shape({
      label: yup
        .string()
        .required(),
      value: yup
        .number()
        .required(),
    }),
  gender: yup
    .string()
    .nullable()
    .defined(),
  services: yup
    .array()
    .required()
    .min(1),
  employee: yup
    .string()
    .when('services', {
      is: (services: Array<any>) => services.some((service) => service.extra?.isEmployeeMandatory === true),
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable(),
    }),
  lastName: yup
    .string()
    .required(),
  firstName: yup
    .string()
    .required(),
  email: yup
    .string()
    .nullable()
    .email(),
  phoneNumber: yup
    .string()
    .required()
    .matches(/^\+?\d+$/),
  earmold: yup
    .boolean()
    .optional(),
});
